<template>
  <div>
    <Operator
      :disabled="disabled"
      :operators="operators"
      :rules="rules.comparation"
      :value.sync="compareType"/>
    <sFormItem
      v-if="$_showParametersWithOperator"
      prop="parameters"
      :rules="rules.parameters">
      <CategoryDropdownTree
        data-qa="category"
        :disabled="disabled"
        input-type="filter"
        :label="$t('Tenders.Category')"
        :model="classifications"
        multiple
        @update:model="setModel"/>
    </sFormItem>
  </div>
</template>
<script>
import automations from 'mixins/automations.js'
import Operator from 'components/automation/conditions/default/operator.vue'
import CategoryDropdownTree from 'components/common/dialogs/CategoryDropDownTree.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()
/**
 * 2 getAutomation
 * treeView
 */
export default {
  name: 'tenderCategory',
  mixins: [ automations ],
  data() {
    const that = this
    return {
      classifications: [],
      rules: {
        comparation: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.compareType) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          },
        },
        parameters: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.parameters?.length) {
              callback(new Error(that.$t('Validate.Required')))
            }
            callback()
          },
        },
      },
    }
  },
  methods: {
    setModel(value) {
      this.classifications = this.$_.cloneDeep(value)
      const result = this.$_.cloneDeep(this.value)
      result.parameters = JSON.stringify(this.classifications?.map(i => i.classificationCode) || [])
      this.$emit('update:value', result)
    },
    getClassification() {
      tender_api.subcategories(this.parameters)
        .then(classifications => {
          this.classifications = classifications
            .map(i => ({
              classificationCode: i.classificationCode,
              title: i.title
            }))
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    compareType: {
      get() {
        if (!this.value?.compareType) {
          return null
        }
        return this.value.compareType
      },
      set(newValue) {
        const result = this.$_.cloneDeep(this.value)
        result.compareType = newValue
        this.$emit('update:value', result)
      }
    },
    parameters: {
      get() {
        if (!this.value || !this.value.parameters) {
          return []
        }
        try {
          const parseParam = JSON.parse(this.value.parameters) || []
          const result = Array.isArray(parseParam) ? parseParam : []
          return result
        } catch {
          return []
        }
      }
    }
  },
  watch: {
    $_showParametersWithOperator: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue && !newValue) {
          this.parameters = null
        }
      }
    }
  },
  components: {
    Operator,
    CategoryDropdownTree
  },
  mounted() {
    this.getClassification()
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    operators: {
      type: Array
    },
  },
}
</script>
